import React, {useEffect, useRef} from 'react';
import styles from './Gallery.module.scss'
import layerStyles from "../heroLayers/Layers.module.scss";
import macroStyles from "components/homePanels/f-i_macroPage/MacroPage.module.scss";
import ImageWrapper from "components/imageWrapper/ImageWrapper";
import ScrollMagic from "scrollmagic";
import {TimelineMax, TweenMax} from "gsap";
import CacheSquare from "components/homePanels/f-i_macroPage/heroLayers/CacheSquare";
import {useSelector} from "react-redux";

const Gallery = (props) => {

    const windowData = useSelector(state => state.window);
    const trigger = useRef();
    const gallery = useRef();

    const quad1_a = useRef();
    const quad1_b = useRef();
    const quad1_c = useRef();
    const quad1_d = useRef();
    const single2 = useRef();
    const quad3_a = useRef();
    const quad3_b = useRef();
    const quad3_c = useRef();
    const quad3_d = useRef();
    const single4 = useRef();
    const quad5_a = useRef();
    const quad5_b = useRef();
    const quad5_c = useRef();
    const quad5_d = useRef();
    const single6 = useRef();

    useEffect(()=>{
        if(windowData.width > windowData.height * 1.5){
            gallery.current.style.width = windowData.height * 1.5 +'px';
            trigger.current.style.top = -((windowData.height - gallery.current.getBoundingClientRect().height)/2)
        } else if(windowData.width <= 768 && (windowData.width * 1.5 > windowData.height )){
            gallery.current.style.width = windowData.height  * .66 +'px';
            let galleryHeight = gallery.current.offsetHeight - 200
            let gap = ((galleryHeight - windowData.height)/2)
            trigger.current.style.top = gap + 'px';
        } else  {
            gallery.current.style.width = '100%';
            let galleryHeight = gallery.current.offsetHeight - 200 /* padding bottom **/;
            let gap = ((galleryHeight - windowData.height)/2)
            trigger.current.style.top = gap + 'px';
        }
    },[windowData]);

    useEffect(()=>{

        if(gallery.current){

            let timeout = setTimeout(()=>{

                let controller = new ScrollMagic.Controller({
                    container: props.scroller
                });

                let timeline = new TimelineMax();
                let finalOpts = {opacity: 1, /*scale: 1,*/ transform: 'translate(0,0'};
                let startOpts = {opacity: 0, /*scale: .2*/};
                let mobile = windowData.width <= 768;

                /** Square 1 **/

                let elem1_a = TweenMax.fromTo(quad1_a.current,
                    {...startOpts, xPercent: mobile ? 175 : 275, yPercent: mobile ? 275 : 200},
                    { ...finalOpts, delay: 0.1 });

                let elem1_b = TweenMax.fromTo(quad1_b.current,
                    {...startOpts, xPercent: mobile ? 75 : 175, yPercent: mobile ? 275 : 200},
                    { ...finalOpts, delay: 0.3 });

                let elem1_c = TweenMax.fromTo(quad1_c.current,
                    {...startOpts, xPercent: mobile ? 175 : 275, yPercent: mobile ? 200 : 100},
                    { ...finalOpts, delay: 0, });

                let elem1_d = TweenMax.fromTo(quad1_d.current,
                    {...startOpts, xPercent: mobile ? 75 : 175, yPercent: mobile ? 175 : 100},
                    { ...finalOpts, delay: 0.2 });

                /** Square 2 **/
                let elem2 = TweenMax.fromTo(single2.current,
                    {...startOpts, xPercent: mobile ? 0 : 0, yPercent: mobile ? 100 : 0},
                    { ...finalOpts, delay: 0.7 });

                /** Square 3 **/
                let elem3_a = TweenMax.fromTo(quad3_a.current,
                    {...startOpts, xPercent: mobile ? -10 : -125, yPercent: mobile ? 100 : 200},
                    { ...finalOpts, delay: 0.3 });

                let elem3_b = TweenMax.fromTo(quad3_b.current,
                    {...startOpts, xPercent: mobile ? -100 : -225, yPercent: mobile ? 100 : 200},
                    { ...finalOpts, delay: 0.2 });

                let elem3_c = TweenMax.fromTo(quad3_c.current,
                    {...startOpts, xPercent: mobile ? -10 : -125, yPercent: mobile ? 0 : 100},
                    { ...finalOpts, delay: 0 });

                let elem3_d = TweenMax.fromTo(quad3_d.current,
                    {...startOpts, xPercent: mobile ? -100 : -225, yPercent: mobile ? 0 : 100},
                    { ...finalOpts, delay: 0.4 });

                /** Square 4 **/
                let elem4 = TweenMax.fromTo(single4.current,
                    {...startOpts, xPercent: mobile ? 5 : 125, yPercent: mobile ? 0 : 0},
                    { ...finalOpts, delay: 0.2 });

                /** Square 5 **/
                let elem5_a = TweenMax.fromTo(quad5_a.current,
                    {...startOpts, xPercent: mobile ? 150 : 75, yPercent: mobile ? -75 : 10},
                    { ...finalOpts, delay: 0.3 });

                let elem5_b = TweenMax.fromTo(quad5_b.current,
                    {...startOpts, xPercent: mobile ? 85 : -25, yPercent: mobile ? -100 : 10},
                    { ...finalOpts, delay: 0.2 });

                let elem5_c = TweenMax.fromTo(quad5_c.current,
                    {...startOpts, xPercent: mobile ? 150 : 75, yPercent: mobile ? -175 : -100},
                    { ...finalOpts, delay: 0.5 });

                let elem5_d = TweenMax.fromTo(quad5_d.current,
                    {...startOpts, xPercent: mobile ? 85 : -25, yPercent: mobile ? -200 : -100},
                    { ...finalOpts, delay: 0.4 });

                /** Square 6 **/
                let elem6 = TweenMax.fromTo(single6.current,
                    {...startOpts, xPercent: mobile ? -10 : -50, yPercent: mobile ? -50 : 0},
                    { ...finalOpts, delay: 0.3 });

                let elements = [elem1_a,elem1_b,elem1_c,elem1_d,elem2,elem3_a,elem3_b,elem3_c,elem3_d,
                    elem4,elem5_a,elem5_b,elem5_c,elem5_d,elem6];

                let children = [];
                elements.forEach((el)=>{
                    children.push(
                        TweenMax.fromTo(el._targets[0].firstChild,
                            {transform: 'translateZ(-400px) perspective(200px)'},
                            {transform: 'translateZ(0px) perspective(200px)'}
                        ));
                })
                elements.push(children);

                timeline.add(elements);

                new ScrollMagic.Scene({
                    reverse: true,
                    triggerElement: trigger.current,
                    triggerHook: 'onLeave',
                    duration: '100%'})
                    .setTween(timeline)
                    .setPin(gallery.current)
                    .addTo(controller);


            },200);

            return ()=>clearTimeout(timeout)

        }


    },[props.scroller, windowData])


    function buildBgLayers(){
        if(props.macro === 'cache'){
            return (
                <>
                    <div className={layerStyles.cacheSquare1}>
                        <CacheSquare/>
                    </div>
                    <div className={layerStyles.cacheSquare2}>
                        <CacheSquare/>
                    </div>
                </>
            )
        }

        if(props.macro === 'martellus'){
            return (
                <>
                    <div aria-hidden={true} className={layerStyles.martellus_videoGirl}>
                        <ImageWrapper set={{default: 'https://msobd-storage.azureedge.net/images/profile_martellus/bg-bonus-girl.png'}} alt={'Girl'}/>
                    </div>

                </>
            )
        }
    }


    return (
        <div key={windowData.width} className={styles.galleryWrapper}>
            <div ref={trigger} className={styles.trigger}/>
            <div aria-label={props.galleryLabel} ref={gallery} className={`${macroStyles.macroPanel} ${styles.gallery}`}>
                <div className={`${styles.quad} ${styles.square1}`}>
                    <div><div ref={quad1_a}><ImageWrapper set={{default:`https://msobd-storage.azureedge.net/images/profile_${props.macro}/image1_a.jpg`}} alt={`${props.title} Lifestyle photo`}/></div></div>
                    <div><div ref={quad1_b}><ImageWrapper set={{default:`https://msobd-storage.azureedge.net/images/profile_${props.macro}/image1_b.jpg`}} alt={`${props.title} Lifestyle photo`}/></div></div>
                    <div><div ref={quad1_c}><ImageWrapper set={{default:`https://msobd-storage.azureedge.net/images/profile_${props.macro}/image1_c.jpg`}} alt={`${props.title} Lifestyle photo`}/></div></div>
                    <div><div ref={quad1_d}><ImageWrapper set={{default:`https://msobd-storage.azureedge.net/images/profile_${props.macro}/image1_d.jpg`}} alt={`${props.title} Lifestyle photo`}/></div></div>
                </div>
                <div className={`${styles.single} ${styles.square2}`}>
                    <div><div ref={single2}><ImageWrapper set={{default:`https://msobd-storage.azureedge.net/images/profile_${props.macro}/image2.jpg`}} alt={`${props.title} Lifestyle photo`}/></div></div>
                </div>
                <div className={`${styles.quad} ${styles.square3}`}>
                    <div><div ref={quad3_a}><ImageWrapper set={{default:`https://msobd-storage.azureedge.net/images/profile_${props.macro}/image3_a.jpg`}} alt={`${props.title} Lifestyle photo`}/></div></div>
                    <div><div ref={quad3_b}><ImageWrapper set={{default:`https://msobd-storage.azureedge.net/images/profile_${props.macro}/image3_b.jpg`}} alt={`${props.title} Lifestyle photo`}/></div></div>
                    <div><div ref={quad3_c}><ImageWrapper set={{default:`https://msobd-storage.azureedge.net/images/profile_${props.macro}/image3_c.jpg`}} alt={`${props.title} Lifestyle photo`}/></div></div>
                    <div><div ref={quad3_d}><ImageWrapper set={{default:`https://msobd-storage.azureedge.net/images/profile_${props.macro}/image3_d.jpg`}} alt={`${props.title} Lifestyle photo`}/></div></div>
                </div>
                <div className={`${styles.single} ${styles.square4}`}>
                    <div><div ref={single4}><ImageWrapper set={{default:`https://msobd-storage.azureedge.net/images/profile_${props.macro}/image4.jpg`}} alt={`${props.title} Lifestyle photo`}/></div></div>
                </div>
                <div className={`${styles.quad} ${styles.square5}`}>
                    <div><div ref={quad5_a}><ImageWrapper set={{default:`https://msobd-storage.azureedge.net/images/profile_${props.macro}/image5_a.jpg`}} alt={`${props.title} Lifestyle photo`}/></div></div>
                    <div><div ref={quad5_b}><ImageWrapper set={{default:`https://msobd-storage.azureedge.net/images/profile_${props.macro}/image5_b.jpg`}} alt={`${props.title} Lifestyle photo`}/></div></div>
                    <div><div ref={quad5_c}><ImageWrapper set={{default:`https://msobd-storage.azureedge.net/images/profile_${props.macro}/image5_c.jpg`}} alt={`${props.title} Lifestyle photo`}/></div></div>
                    <div><div ref={quad5_d}><ImageWrapper set={{default:`https://msobd-storage.azureedge.net/images/profile_${props.macro}/image5_d.jpg`}} alt={`${props.title} Lifestyle photo`}/></div></div>
                </div>
                <div className={`${styles.single} ${styles.square6}`}>
                    <div><div ref={single6}><ImageWrapper set={{default:`https://msobd-storage.azureedge.net/images/profile_${props.macro}/image6.jpg`}} alt={`${props.title} Lifestyle photo`}/></div></div>
                </div>
            </div>

            {buildBgLayers()}

        </div>
    )
};

export default Gallery
